import React, { useRef } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

import styles from '../../../../searchV2.scss';

const LocationSearch = (props) => {
    const locationInputRef = useRef(null);

    const focusInput = () => {
        locationInputRef.current.focus();
    };

    const {
        value,
        geoLocation,
        onChange,
        onSelect,
        className,
        onCurrentLocationClick,
        handleClearClick,
    } = props;

    const searchOptions = {
        types: ['(regions)'], // https://developers.google.com/places/supported_types#table3
    };

    return (
        <PlacesAutocomplete
            value={value}
            onChange={onChange}
            onSelect={onSelect}
            searchOptions={searchOptions}
        >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className={`search-autocomplete-root d-block`}>
                    <div className={styles.locationInputWrapper}>
                        <input
                            ref={locationInputRef}
                            {...getInputProps({
                                placeholder: 'Enter location here',
                                className: `${className} ${styles.locationInput}`,
                            })}
                        />
                        {value && value.length > 0 && (
                            <button
                                type="button"
                                className={styles.locationClearButton}
                                onClick={() => handleClearClick(focusInput)}
                                aria-label="Clear location"
                            >
                                <img src="/img/v4/close-icon.svg" alt="Clear" />
                            </button>
                        )}
                    </div>
                    <div className="autocomplete-dropdown-container search-autocomplete-container">
                        {loading && <div>Loading...</div>}
                        {suggestions?.length > 0 && geoLocation &&
                            <div className="current-location" onMouseDown={onCurrentLocationClick}>Current location</div>}
                        {suggestions?.map((suggestion, index) => {
                            const classNm = suggestion?.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                            return (
                                <div
                                    key={suggestion?.placeId || index}
                                    {...getSuggestionItemProps(suggestion, {
                                        className: classNm,
                                    })}
                                >
                                    <span>{suggestion?.description}</span>
                                </div>
                            );
                        })}
                        {suggestions?.length > 0 && (
                            <div className="powered-by-google" />
                        )}
                    </div>
                </div>
            )}
        </PlacesAutocomplete>
    );
};

export default LocationSearch;
